let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ciUip")).then(() => parcelRequire('eEUNg'));